"use client";

import type { requestTravelAction } from "@/actions/requestTravel";
import { RequestTravel } from "@/app/(main)/voyage/[aliasId]/_components/RequestTravel";
import type { SearchDeparture, SearchTravel } from "front-search-schema/algolia";
import { SecondaryButton } from "ui/components";

type Props = {
  travel: SearchTravel;
  departure: SearchDeparture;
  requestTravelAction: typeof requestTravelAction;
};
export const RequestTravelClient = ({ travel, departure, requestTravelAction }: Props) => {
  return (
    <RequestTravel
      travelId={travel.id}
      departureId={departure.id}
      travelTitle={travel.title}
      versionId={departure.versionId}
      requestTravelAction={requestTravelAction}
      onSuccess={() => {
        return;
      }}
    >
      <SecondaryButton className="w-full px-4!" direction="up" size="sm">
        Recevoir une alerte
      </SecondaryButton>
    </RequestTravel>
  );
};
